export type Quadrant =
  | 'Scripted'
  | 'Exploratory'
  | 'Observable'
  | 'Collaborative';
export type Ring = 'CodeLevel' | 'UserLevel' | 'BusinessLevel';

export interface AuditNote {
  id: string;
  content: string;
  createdAt: Date;
  createdBy: string;
}

export interface Practice {
  id: string;
  name: string;
  description: string;
  quadrant: Quadrant;
  ring: Ring;
  emoji: string;
  auditTrail: AuditNote[];
}

export interface Radar {
  id: string;
  tenantId: string;
  teamId: string;
  name: string;
  description: string;
  practices: Practice[];
  createdAt: Date;
  updatedAt: Date;
}

export const QUADRANT_NAMES: Quadrant[] = [
  'Scripted',
  'Observable',
  'Exploratory',
  'Collaborative',
];
